var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.temp_data),function(item,index){return _c('span',{key:index},[_c('span',{class:_vm.statusBadgeClass(item.Status)},[_vm._v(" "+_vm._s(item.Num)+" "+_vm._s(_vm.statusTranslation(item.Status))+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }